import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BaseEditor from './pages/BaseEditor'
import BaseEditorDiscipline from './pages/BaseEditorDiscipline'
import registerServiceWorker from './registerServiceWorker';
import { Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import '@material-ui/core'

// Our Components
import Login from './components/Login';
import { Switch } from '@material-ui/core';

ReactDOM.render(
    <Router>
        <React.Fragment>
            <Route exact path="/" render={() => <Redirect to="/editor" />} />
            <Route exact path="/editor" render={props => <BaseEditor {...props} />} />
            <Route exact path="/editor/:disciplineid/:languageid" render={props => <BaseEditorDiscipline {...props} />} />
            <Route exact path="/login" component={Login} />
        </React.Fragment>
    </Router>
    , document.getElementById('root')
);
// registerServiceWorker();
